import { EntityService } from './EntityService';
import { IEntity, INAODefForm } from '../types';

export class EditionService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/Editions`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IEntity[]> {
        return this.readAll();
    }
}